// removed by extract-text-webpack-plugin
module.exports = {"header":"_19RwX9cJXnVkCl49zy5e-h","wrapper":"D2mPDltFbdTMoPzyCYkgj","logoSection":"ubiSay_gYNZq60jLz5I2U","sectionInner":"_1uPOEQlBYgrCPakeq7rAXA"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/layout/Header.css
// module id = 432
// module chunks = 0